import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import shortid from 'shortid'

import parseText from '../../pattern_utilities/parseText'
import { pmUpdateFromText, pmUpdateFromHybrid, showTooltip, hideTooltip } from '../../actions/actions.export.js';

import Button from '../Button/Button.js'

import './TextEditor.css';

var textEditorTimeout;

class TextEditor extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      isHovering: false
    }

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    const { dispatch, cacheID, patternManager } = this.props; 

    clearTimeout(textEditorTimeout);
    textEditorTimeout = setTimeout(function(){
      
      dispatch(pmUpdateFromText({
        pattern: parseText(e.target.value),
        sendToServer: patternManager.cache[cacheID].linkedToServer,
        cacheID: cacheID,
        regenText: false
      }));
    }, 250);
  }

  render(){

    const { dispatch, cacheID, patternManager } = this.props; 

    var pattern = patternManager.cache[cacheID];
   
    return (
      <div className={"text-editor " + (this.props.demo ? "text-editor-demo " : "") + (pattern.mode !== 'raster' ? "text-editor-disabled" : "")} style={{height: this.props.height}}>
        {
          pattern.mode === 'raster' ? 
            <Field 
              name="text" 
              component="textarea" 
              type="text" 
              onChange={this.handleChange} 
              readOnly={pattern.mode === 'raster' ? false : true }
              />
          :
          <div className="text-viewer-wrapper">
            <div 
              className="text-viewer" 
              onMouseEnter={(e)=>{ this.setState({isHovering: true })}}
              onMouseLeave={(e)=>{ this.setState({isHovering: false })}}
              >
              {
                pattern.text
              }
            </div>
              
              <div className="text-viewer-bake-warning-wrapper">
                <div className="text-viewer-bake-warning">
                  <p>
                    Bake this pattern to make manual changes.&nbsp;
                    <span
                      className="has-tooltip"
                      onMouseEnter={(e)=>{ 
                        dispatch(showTooltip({
                          e: e,
                          position: 'top', 
                          lag: 100,
                          nobr: false,
                          content: <div style={{width: 200}}>
                            Baking a pattern finalizes the drawing or template data, allowing you to make manual changes to the raw .PAT file.
                          </div>
                        }))
                      }} 
                      onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                      >
                      <i className="fal fa-question-circle text-grey-primary"/>
                    </span>
                  </p>
                  <Button
                    display="Bake Pattern"
                    size="medium"
                    color="warning"
                    onClick={(e)=>{ 
                        dispatch(pmUpdateFromHybrid({
                          cacheID: cacheID, 
                          pattern: {
                            mode: 'raster' 
                          }
                        })); 
                      }} 
                  />
                </div>
              </div>
            
          </div>  
        }
      </div>
    )
  }
}


TextEditor = reduxForm({
  // a unique name for the form
  form: 'TextEditor-' + shortid.generate(),
  enableReinitialize: true,
  destroyOnUnmount: false
})(TextEditor)


TextEditor = connect((state, ownProps) => {
  const { patternManager } = state;

  // console.log(state);
  var initialValues = {
    text: patternManager.cache[ownProps.cacheID].text
  };

  return {
    patternManager,
    initialValues,
    state
  }
})(TextEditor);


export default TextEditor;


// WEBPACK FOOTER //
// ./src/components/TextEditor/TextEditor.js